import * as Yup from 'yup';

export const commonPromptYupValidation = () => {
  return Yup.object().shape({
    description: Yup.string().required('required'),
  });
};
